var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoorOutSolid = function SvgDoorOutSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 18H15.5C15.7762 18 16 18.2238 16 18.5V19.5C16 19.7762 15.7762 20 15.5 20H2.5C2.22375 20 2 19.7762 2 19.5V18.5C2 18.2238 2.22375 18 2.5 18H3.99969V5.5875C3.99969 4.71187 4.6725 4 5.49969 4H12.5C13.3272 4 14 4.71187 14 5.5875V18ZM9.99969 12C9.99969 12.5522 10.4475 13 10.9997 13C11.5522 13 12 12.5522 11.9997 12C11.9997 11.4478 11.5519 11 10.9997 11C10.4475 11 9.99969 11.4478 9.99969 12ZM18.3603 11.013L18.3216 9.69888C18.3216 9.07748 19.0693 8.7663 19.5066 9.20569L21.7972 11.5072C22.0683 11.7796 22.0673 12.2202 21.7962 12.4926L19.5056 14.7941C19.0683 15.2335 18.3216 14.9233 18.3216 14.3019L18.3603 12.9857H16V11.013H18.3603Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoorOutSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/door_out_solid.f6c522e3.svg";
export { ForwardRef as ReactComponent };